// src/api/axiosInstance.ts

import axios, { AxiosError, AxiosInstance } from 'axios';

import { API_URI } from '@/constants/env';
import { getLoginPath } from '@/helpers/url';

const instance: AxiosInstance = axios.create({
  baseURL: API_URI,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      setAuthToken();
      window.location.href = getLoginPath();
    }
    return Promise.reject(error);
  },
);

// Set the token for all requests
export const setAuthToken = (token?: string) => {
  instance.defaults.headers.common['Authorization'] = token ? `Token ${token}` : '';
};

export default instance;
